import { useMemo } from 'react'
import { useSearchParams } from 'react-router'

// This hook returns a list of search params that are allowed to be passed to the component.
export function useAllowlistSearchParams({ allowedKeys }: { allowedKeys: string[] }) {
  const [searchParams] = useSearchParams()
  const search = searchParams.toString()
  const allowedKeysKey = allowedKeys.join(',')

  const allowedParams = useMemo(() => {
    const params = new URLSearchParams(search)
    return allowedKeysKey.split(',').reduce<Partial<Record<(typeof allowedKeys)[number], string>>>((acc, key) => {
      const value = params.get(key)
      if (value != null) acc[key] = value
      return acc
    }, {})
  }, [search, allowedKeysKey])
  return { allowedParams }
}
